export default __webpack_public_path__ + "static/whatsapp-acdebbd1f848eb5dbf433f52bced3f62.png";